import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import parse from 'html-react-parser';
//Estilo Primario
import '../../../../assets/dist/stilo.css'
// import { NavItem, Nav } from 'react-bootstrap'
//Logos
// import d1 from '../../../../assets/dist/svg/main.svg';
// import d2 from '../../../../assets/dist/svg/main.svg';
// import Footer from '../../../util/Footer';
// import NewHeaderInicio from '../../../util/NewHeaderInicio';
// import { CircularProgress } from '@material-ui/core';
/* import ScriptTag from 'react-script-tag'; */
import { ObtieneCondicionesLogic } from '../../../view-model/Inicio/PostulacionesEstudiante.logic';
// import queryString from 'query-string';
// import { animateScroll as scroll } from 'react-scroll';
// import { EnvioCorreoDeclaracionLogic } from '../../../view-model/Matricula/Matricula.logic';
// import IViewPostulante from '../../../view-interfaces/IViewPostulante';
//import { ObtieneDatosPostulanteLogic } from '../../../view-model/Inicio/InicioEstudiante.logic';
import { ObtieneDatosPersonalesLogic } from '../../../view-model/DatosPersonales/DatosPersonales.logic';

import Box from '@material-ui/core/Box';
// import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import MensajeToken from '../../../../Components/MensajeToken/MensajeToken';

type Props = { onClickContinuar: any }
export const Validacion: React.FC<Props> = ({ onClickContinuar }) => {
    const history = useHistory();

    const location = useLocation();
    //const [_base64, setBase64] = useState('')
    const [_xml, setXML] = useState('')
    const [nombreAlumno, setNombreAlumno] = useState('')
    const [aceptado, setAceptado] = useState(false)
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
    const [codNegocio, setCodNegocio] = useState(0)

    useEffect(() => {
        if (location.state === null || location.state === undefined) {
            history.push({
                pathname: "/Inicio"
            });
        } else {
            sessionStorage.setItem('fase', JSON.stringify('validacion'))
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt)
            setCodNegocio(_params.headers.codNegocio)
            ObtieneCondicionesLogic(selListaCondiciones, _params.rut);
            //ObtieneDatosPostulanteLogic(selListaPostulante, _params.rut, _params.CodigoNegocio);
            ObtieneDatosPersonalesLogic(selListaPostulante, _params.headers, _params.rut, "", _params.CodigoNegocio, 1);
        }
    }, [])
    const selListaPostulante = (error: Boolean, err: string, Estudiante: any) => {
        try {
            if (error === false && Estudiante[0].run.toString().trim().length > 1) {
                // let _postulante: Array<IViewPostulante> = [];

                setNombreAlumno(Estudiante[0].nombreCompleto)

            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }

        } catch (error) {
            console.log('error', error);
        }
    }
    const selListaCondiciones = (error: Boolean, err: string, Instrucciones: any) => {
        if (error === false && Instrucciones !== undefined) {
            console.log(Instrucciones)
            if (Instrucciones.length > 0) {
                //setBase64(Instrucciones[0].instrucciones.base64[0].trim());
                setXML(Instrucciones[0].instrucciones.xml)
            }

        }
    }
    const envioCorreo = () => {
        // let _tt = JSON.stringify(location.state);
        // let _params = JSON.parse(_tt)
        /* console.log(_params) */
        //EnvioCorreoDeclaracionLogic(selEnvioCorreo, _params.rut, _base64, nombreAlumno, _params.NombreCarrera,_params.codCarrera)
    }
    // const selEnvioCorreo = (error: Boolean, err: string, data: any) => {
    //     if (error === false && data !== undefined) {
    //         console.log("Se envío el correo exitosamente")
    //     } else {
    //         console.log("Problemas al enviar el correo")
    //     }
    //     onClickContinuar("7")
    // }
    return (
        <>
            {/* <div style={{height:'60rem'}}>
                <iframe src={"data:application/pdf;base64," + texto} height="100%" width="100%"></iframe>
            </div> */}
            <div className='declaracion'>
                {parse(_xml)}
            </div>


            <div style={{ fontFamily: 'sans-serif', textAlign: 'center', height: '100%', display: 'grid', placeContent: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <FormControl component="fieldset" variant="standard">
                        <FormGroup>
                            <div style={{ display: 'block' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={aceptado}
                                            onChange={(e, h) => {
                                                setAceptado(h)
                                            }}
                                        />
                                    }
                                    label={''}
                                />
                                <label className="text-nowrap">{`Acepto Declaración`}</label>
                            </div>
                        </FormGroup>
                    </FormControl>
                </Box>
                <br />
                <button onClick={() => {
                    envioCorreo()
                }} id="payment-submit__button" className="btn btn-primary js-needs-confirmation" disabled={!aceptado} type="submit">Acepto condiciones</button>
            </div>
            <br />
            <br />
            <br />
            <br />
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
                    :
                    ""
            }
        </>
    );
}
